import * as MUTATIONS from './mutation-types.js';
import defaultState from './state';
import { captureError } from "@/services/userMonitoring";

let newState = {};
Object.assign(newState, defaultState);
export const businessUnitContactDetailsModule = {
  state: newState,
  mutations: {
    [MUTATIONS.CLEAR]: (state) => { Object.assign(state, defaultState) },
    [MUTATIONS.BUSINESS_UNIT_CONTACT_DETAILS]: (state, value) => { state.BUSINESS_UNIT_CONTACT_DETAILS = value },
  },
  actions: {
    getContactDetails: async function({commit}) {
      try {
        let result = await this._vm.$api.businessUnitContactDetails.getContactDetails();
        commit(MUTATIONS.BUSINESS_UNIT_CONTACT_DETAILS, result.data.data[0]);
        return result.data.data[0];
      } catch (e) {
        captureError(e, {
          section: "contact",
          action: "get-phone",
          type: "api-request",
        });
      }
    }
  }
};
